import { render, staticRenderFns } from "./catList.vue?vue&type=template&id=4cf4e170&"
import script from "./catList.vue?vue&type=script&lang=js&"
export * from "./catList.vue?vue&type=script&lang=js&"
import style0 from "./catList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports